module.exports = __webpack_public_path__ + "static/media/GU.753ae3b4.svg";